
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/security",
      function () {
        return require("private-next-pages/[lang]/security.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/security"])
      });
    }
  